__turbopack_context__.v({
  "treesNumber": "O6AJDa_treesNumber",
  "updateButton": "O6AJDa_updateButton",
  "wrapper": "O6AJDa_wrapper",
});
